import { createMuiTheme, Theme } from '@material-ui/core';
import { colors, MUIComponentsTheme } from '@lifesize/clients.mui-components';
import _merge from 'lodash/merge';

const fontFamilyPrimary = 'LsFont';

// this is a temp fix until mui-components update is tagged
MUIComponentsTheme.typography = _merge(MUIComponentsTheme.typography, {
  fontFamily: fontFamilyPrimary,
  fontSize: 14,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
  body1: {
    fontFamily: fontFamilyPrimary,
    fontSize: '14px'
  },
  body2: {
    fontFamily: fontFamilyPrimary,
    fontSize: '1.4rem'
  },
  button: {
    fontFamily: fontFamilyPrimary,
    fontSize: '1.6rem',
    fontWeight: 500,
    letterSpacing: '0.5px',
    lineHeight: 1.5,
    textTransform: 'none'
  },
  caption: {
    fontFamily: fontFamilyPrimary
  },
  h1: {
    fontFamily: fontFamilyPrimary,
    fontSize: '3.2rem',
    fontWeight: 500,
    lineHeight: 1.25
  },
  h2: {
    fontFamily: fontFamilyPrimary,
    fontSize: '2.4rem',
    fontWeight: 500,
    lineHeight: 1.33
  },
  h3: {
    fontFamily: fontFamilyPrimary,
    fontSize: '2.0rem',
    fontWeight: 500,
    lineHeight: 1.4
  },
  h4: {
    fontFamily: fontFamilyPrimary,
    fontSize: '1.8rem',
    fontWeight: 'normal',
    lineHeight: 1
  },
  h5: {
    fontFamily: fontFamilyPrimary,
    fontSize: '1.6rem',
    fontWeight: 'normal',
    lineHeight: 1
  },
  h6: {
    fontFamily: fontFamilyPrimary,
    fontSize: '1.4rem',
    fontWeight: 'normal',
    lineHeight: 1
  },
  overline: {
    fontFamily: fontFamilyPrimary
  },
  subtitle1: {
    color: colors.lightSlateGray,
    fontFamily: fontFamilyPrimary,
    fontSize: '1.6rem'
  },
  subtitle2: {
    fontFamily: fontFamilyPrimary
  }
});

MUIComponentsTheme.overrides = _merge(MUIComponentsTheme.overrides, {
  MuiRadio: {
    fontSize: '16px',
    colorSecondary: {
      color: colors.lifesize,
      '&.Mui-checked': {
        color: colors.lifesize
      }
    }
  }
});

export const theme: Theme = createMuiTheme(MUIComponentsTheme);
